import React, { Component } from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import './content.css';
import Page404 from '../universal/page404/page404.js';
import User from './user/user.js';
import Home from './home/home.js';
import About from './about/about.js';
import InstanceScreenshotViewer from './instanceScreenshotViewer/instanceScreenshotViewer.js';
import Feedback from './feedback/feedback.js';
import Ec2Explorer from './ec2Explorer/ec2Explorer.js';
import Ec2ResExplorer from './ec2ResExplorer/ec2ResExplorer.js';
import Ec2PatchErrors from './ec2PatchErrors/ec2PatchErrors.js';
import AwsCostExplorer from './awsCostExplorer/awsCostExplorer.js';
import HybrisSiteIdentifier from './hybrisSiteIdentifier/hybrisSiteIdentifier.js';
import IamExplorer from './iamExplorer/iamExplorer.js';
import IamExActions from './iamExplorer/iamExActions/iamExActions.js';
import IamExUsers from './iamExplorer/iamExUsers/iamExUsers.js';
import IamExReport from './iamExplorer/iamExReport/iamExReport.js';
import IamExKeys from './iamExplorer/iamExKeys/iamExKeys.js';
import SecurityFeeds from './securityFeeds/securityFeeds.js';
import MaintenanceMonitor from './maintenanceMonitor/maintenanceMonitor.js';
import SecurityGroupComparer from './securityGroupComparer/securityGroupComparer.js';
import LandscapeInfo from './landscapeInfo/landscapeInfo.js';
import InstanceTerraform from './instanceTerraform/instanceTerraform.js';

import CostExplorer from './awsCostExplorer/awsCostExplorer.js';

class Content extends Component {

  state = {

  }

  componentDidMount() {

  }

  render() {

    const {loggedIn} = this.props;

    return (
      <div className="ContentPage">
        {!loggedIn && <Redirect to="/"/>}
        <Switch>
          <Route exact path="/" render={(props) => <User {...props} checkUsersGroup={this.props.checkUsersGroup}/>}/>
          <Route path="/home" component={Home}/>
          <Route path="/about" component={About}/>
          <Route path="/securityFeeds" component={SecurityFeeds}/>
          <Route path="/hybrisSiteIdentifier" component={HybrisSiteIdentifier}/>
          <Route path="/instanceScreenshotViewer" component={InstanceScreenshotViewer}/>
          <Route path="/ec2Explorer" component={Ec2Explorer}/>
          <Route path="/ec2ResExplorer" component={Ec2ResExplorer}/>
          <Route path="/ec2PatchErrors" component={Ec2PatchErrors}/>
          <Route path="/awsCostExplorer" component={AwsCostExplorer}/>
          <Route exact path="/iamExplorer" component={IamExplorer}/>
          <Route path="/iamExplorer/actions" component={IamExActions}/>
          <Route path="/iamExplorer/users" component={IamExUsers}/>
          <Route path="/iamExplorer/keys" component={IamExKeys}/>
          <Route path="/iamExplorer/report" component={IamExReport}/>
          <Route path="/maintenanceMonitor" component={MaintenanceMonitor}/>
          <Route path="/securityGroupComparer" component={SecurityGroupComparer}/>
          <Route path="/feedback" component={Feedback}/>
          <Route path="/costExplorer" component={CostExplorer}/>
          <Route path="/landscapeInfo" component={LandscapeInfo}/>
          <Route path="/instanceTerraform" component={InstanceTerraform}/>
          <Route component={Page404}/>
        </Switch>
      </div>
    );
  }

}

export default Content;


// WEBPACK FOOTER //
// ./src/components/content/content.js